"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ProductionResource = /** @class */ (function (_super) {
    tslib_1.__extends(ProductionResource, _super);
    function ProductionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductionResource.endpoint = '/productions';
    ProductionResource.MODEL_NAME = 'production';
    return ProductionResource;
}(base_1.default));
exports.default = ProductionResource;
//# sourceMappingURL=production.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/production.js
// module id = Ectq
// module chunks = 0